import classNames from 'classnames';
import { useTileDataContext } from '~/contexts/TileDataContext';
import { formatDateAndMonth } from '../helpers/ResultTile.helpers';
import { useHideGetItBy } from '../hooks';

type OwnProps = {
  getItBy: string;
};

export default function GetItBy({ getItBy }: OwnProps) {
  const hideGetItBy = useHideGetItBy(getItBy);

  const { tileData } = useTileDataContext();
  const { soonestAvailabilityInfo: { dateAvailable } = {} } = tileData;

  const shouldBold = getItBy === 'Today' || getItBy === 'Tomorrow';

  return dateAvailable ? (
    <div
      data-qa="get-it-by"
      className={classNames(
        { 'text-grey-5': !shouldBold },
        {
          invisible: hideGetItBy
        },
        { 'font-bold text-blue-6': shouldBold }
      )}
    >
      {`Get it ${
        shouldBold ? getItBy : `by ${formatDateAndMonth(dateAvailable)}`
      }`}
    </div>
  ) : null;
}
